import { isSiteDomain } from "../../settings/domainManager";
import { get_shop_uid_from_url } from "./shop";

export function navigate_to_product(shop_uid, product_id, isManager) {
  let link = `/p/${product_id}`;
  if (isManager) {
    link = `${link}/?isManager=true`;
  }
  if (!isSiteDomain) {
    link = `/${shop_uid}${link}`;
  }
  return link;
}

export function navigate_to_shop_personalized_product(shop_uid) {
  let link = `/personalized-product`;
  if (!isSiteDomain) {
    link = `/${shop_uid}${link}`;
  }
  return link;
}

export function navigate_to_shop_personalized_product_from_url() {
  return navigate_to_shop_personalized_product(get_shop_uid_from_url());
}
